/*
 *
 * File JS per la Homepage
 *
 */

import "./general.scss";
import "swiper/css/bundle";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import initHeader from "components/header/header";
import breadcrumbs from "components/breadcrumbs/breadcrumbs";
import button from "components/buttons/buttons";
import cmsContent from "components/cms-content/cms-content";
import footer from "components/footer/footer";
import contactForm from "components/contact-form/contact-form";
import smallImgText from "components/small-img-text/small-img-text";
import textImgVar from "imComponents/text-img-var/text-img-var";
import heroSlider from "imComponents/hero-slider/hero-slider";
import blockServices from "components/block-services/block-services";
import cardService from "components/cards/card-service";
import cardsTextBg from "components/cards-text-bg/cards-text-bg";
import accordion from "imComponents/accordion/accordion";
import customAccordion from "components/custom-accordion/custom-accordion";
import boxContacts from "components/box-contacts/box-contacts";
import textOnBg from "imComponents/text-on-bg/text-on-bg";
import quotesList from "components/quotes-list/quotes-list";
import quote from "components/cards/quote";
import featuredNews from "components/featured-news/featured-news";
// import archiveFilters from "components/archive-filters/archive-filters";
// import archiveList from "components/archive-list/archive-list";
import cardNews from "components/cards/card-news";
import iconTextList from "imComponents/icon-text-list/icon-text-list";
import iconText from "imComponents/icon-text/icon-text";

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//

initHeader();
heroSlider();
quotesList();
accordion();
//--------------------------------------------------------------------//
